import React, { useState, useEffect } from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: "10px",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  chip: {
    fontSize: 12,
    backgroundColor: "#fff",
    color: "#1B2027",
    borderColor: "#fff",
  },
  clear: {
    backgroundColor: "#1B2027",
    color: "#fff",
    cursor: "pointer",
    "&:hover, &:focus": {
      backgroundColor: "#1B2027 !important",
    },
  },
}));
export default function SelectedPatientsFilter(props) {
  const classes = useStyles();
  const {
    selectedConsultation,
    selectedAppointmentStatus,
    handleConsultation,
    handleAppointmentStatus,
    resetFilter,
  } = props;
  useEffect(() => {}, []);

  const deleteConsultation = () => {
    handleConsultation();
  };

  const deleteAppointmentStatus = () => {
    handleAppointmentStatus();
  };

  const resetAllFilter = () => {
    resetFilter();
  };

  return (
    <div className={classes.root}>
      {selectedConsultation !== "all" && selectedConsultation && (
        <Chip
          label={`Consultation: ${
            (selectedConsultation === "instant"
              ? "Instant Consultation"
              : "") ||
            (selectedConsultation === "inclinic"
              ? "In-Clinic Consultation"
              : "") ||
            (selectedConsultation === "online" ? "Online Consultation" : "")
          }`}
          onDelete={handleConsultation}
          className={classes.chip}
        />
      )}
      {selectedAppointmentStatus !== "all" && selectedAppointmentStatus && (
        <Chip
          label={`Appointment Status: ${selectedAppointmentStatus}`}
          onDelete={handleAppointmentStatus}
          className={classes.chip}
        />
      )}

      {((selectedConsultation !== "all" && selectedConsultation) ||
        (selectedAppointmentStatus !== "all" && selectedAppointmentStatus)) && (
        <Chip
          label="Clear All Filter"
          className={classes.clear}
          variant="outlined"
          onClick={resetFilter}
        />
      )}
    </div>
  );
}
